bq.forecastsWidget = function(element, options) {
    this.$el = $(element);
    this.options = options;
    this._allSystemItems = [];
    this._allOrgItems = [];
    this._currentFilter = 'all';
    this._selectedConfidenceLevels = ['HIGH', 'MEDIUM', 'LOW'];
    this._modelStartDate = '';
    this._modelEndDate = '';
    this._defaultSupplierImageUrl = '';
};

bq.forecastsWidget.DEFAULTS = {
    combinedUrl: '',
    logUrl: '',
    logActionUrl: '',
    supplierImageBaseUrl: '',
    disableWidgetClassification: 0,
    labels: {
        noRecommendations: 'No recommendations found.',
        loadFailed: 'Failed to load recommendations.',
        decreaseQty: 'Decrease Quantity',
        increaseQty: 'Increase Quantity',
        configure: 'Configure',
        addToCart: 'Add to Cart',
        ignore: 'Ignore',
        adding: 'Adding...',
        forecastedFor: 'Forecasted purchases for',
        productNotFound: 'Product not found'
    }
};

bq.forecastsWidget.prototype = {

    init: function() {
        this._defaultSupplierImageUrl = this.options.supplierImageBaseUrl + 'placeholder.jpg';
        this._bindEvents();
        this._load();
    },

    _id: function() {
        return this.$el.attr('id');
    },

    _$: function(suffix) {
        return $('#' + this._id() + suffix);
    },

    _$addAllCart: function() {
        if (this._isNewDesign()) {
            return this.$el.find('[id="' + this._id() + '-add-all-cart"]');
        }
        return this._$('-add-all-cart');
    },

    _refreshIfEmpty: function() {
        if (!this._isNewDesign()) { return; }
        if (!this._$('-suggested tbody tr.bq-suggested-row').length) {
            this._sortAndFilterItems(this._currentFilter);
        }
    },

    _isNewDesign: function() {
        return typeof bq.getIsThemeNew === 'function' && bq.getIsThemeNew();
    },

    _buildImageHtml: function(imageUrl, supplierId, size) {
        return bq.recommendations.buildImageHtml(
            imageUrl, supplierId, this.options.supplierImageBaseUrl, this._defaultSupplierImageUrl, size
        );
    },

    _getContentGroupId: function() {
        return '';
    },

    _getItemKey: function(item) {
        var productId = item.product_id || item.productId;
        if (productId) {
            return 'product:' + String(productId);
        }
        return 'supplier:' + String(item.supplier_id || '') + '|' + String(item.supplier_sku || item.sku || '');
    },

    _itemMatches: function(item, productId, supplierId, sku) {
        if (productId) {
            return String(item.product_id || item.productId || '') === String(productId);
        }
        return String(item.supplier_id || '') === String(supplierId) &&
               String(item.supplier_sku || item.sku || '') === String(sku);
    },

    _splitForecastsBySource: function(forecasts) {
        var systemItems = [];
        var orgItems = [];
        $.each(forecasts || [], function(_, item) {
            if (item.system === true || item.system === 1 || item.system === 'true') {
                systemItems.push(item);
            }
            if (item.org === true || item.org === 1 || item.org === 'true') {
                orgItems.push(item);
            }
        });
        return { system: systemItems, org: orgItems };
    },

    _removeItemFromMemory: function(productId, supplier, sku, recommendationSource) {
        var self = this;
        if (recommendationSource === 'SYS') {
            this._allSystemItems = $.grep(this._allSystemItems, function(item) {
                return !self._itemMatches(item, productId, supplier, sku);
            });
        } else if (recommendationSource === 'ORG') {
            this._allOrgItems = $.grep(this._allOrgItems, function(item) {
                return !self._itemMatches(item, productId, supplier, sku);
            });
        }
    },

    _logRecommendationAction: function(productId, supplierId, sku, recommendationSource, userAction, groupId) {
        if (!this.options.logActionUrl) { return; }
        var payload = {
            recommendation_source: recommendationSource,
            user_action: userAction
        };
        if (productId)  { payload.product_id  = productId;  }
        if (supplierId) { payload.supplier_id  = supplierId; }
        if (sku)        { payload.sku          = sku;        }
        if (groupId)    { payload.group_id     = groupId;    }
        $.ajax({
            url: this.options.logActionUrl,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(payload)
        });
    },

    _sortAndFilterItems: function(filter) {
        var self = this;
        if (this.options.disableWidgetClassification) { filter = 'all'; }

        var $dateRange = this._$('-date-range');
        if (this._modelStartDate && this._modelEndDate && (filter === 'system' || filter === 'all')) {
            $dateRange.html(
                bq.messages.recommendations.forecastedFor +
                ' <strong>' + this._modelStartDate + '</strong>' +
                ' - <strong>' + this._modelEndDate + '</strong>'
            ).show();
        } else {
            $dateRange.hide();
        }

        var items = [];

        if (filter === 'all') {
            var itemMap = {};
            $.each(this._allSystemItems, function(_, item) {
                var key = self._getItemKey(item);
                if (!itemMap[key]) {
                    itemMap[key] = $.extend({}, item);
                    itemMap[key].has_system = true;
                    itemMap[key].has_org = false;
                    itemMap[key].recommendation_source = 'SYS';
                    itemMap[key].source = 'system';
                } else {
                    itemMap[key].has_system = true;
                    if (itemMap[key].has_org) { itemMap[key].recommendation_source = 'SYS'; }
                }
            });
            $.each(this._allOrgItems, function(_, item) {
                var key = self._getItemKey(item);
                if (!itemMap[key]) {
                    itemMap[key] = $.extend({}, item);
                    itemMap[key].has_system = false;
                    itemMap[key].has_org = true;
                    itemMap[key].recommendation_source = 'ORG';
                    itemMap[key].source = 'org';
                } else {
                    itemMap[key].has_org = true;
                    if (itemMap[key].has_system) { itemMap[key].recommendation_source = 'SYS'; }
                }
            });
            var allItems = [];
            $.each(itemMap, function(_, item) { allItems.push(item); });
            allItems.sort(function(a, b) {
                if (a.has_system && !b.has_system) { return -1; }
                if (!a.has_system && b.has_system) { return 1; }
                if (a.has_system && b.has_system) {
                    var rankA = a.recommendation_rank !== undefined ? a.recommendation_rank : 999999;
                    var rankB = b.recommendation_rank !== undefined ? b.recommendation_rank : 999999;
                    return rankA - rankB;
                }
                return 0;
            });
            items = allItems;
        } else if (filter === 'system') {
            items = this._allSystemItems.slice().sort(function(a, b) {
                var rankA = a.recommendation_rank !== undefined ? a.recommendation_rank : 999999;
                var rankB = b.recommendation_rank !== undefined ? b.recommendation_rank : 999999;
                return rankA - rankB;
            });
            $.each(items, function(_, item) {
                item.recommendation_source = 'SYS';
                item.has_system = true;
                item.has_org = false;
            });
        } else if (filter === 'org') {
            items = this._allOrgItems.slice();
            $.each(items, function(_, item) {
                item.recommendation_source = 'ORG';
                item.has_system = false;
                item.has_org = true;
            });
        }

        var selectedConfidenceLevels = this._selectedConfidenceLevels;
        items = $.grep(items, function(item) {
            if (item.recommendation_source === 'ORG' || !item.has_system) { return true; }
            var level = item.confidence_level || '';
            if (!level) { return true; }
            return selectedConfidenceLevels.indexOf(level) !== -1;
        });

        this._renderRows(items);
    },

    _renderRows: function(items) {
        var self = this;
        var containerId = this._id();
        var labels = bq.messages.recommendations;
        var isNewDesign = this._isNewDesign();
        var $tableWrapper = this._$('-list');
        var $table = this._$('-suggested');
        var $tbody = $table.find('tbody');
        var $emptyAlert = $tableWrapper.children('.rec-no-results-alert');
        $tbody.empty();

        var $addAllBtn = this._$addAllCart();
        var hasProducts = false;
        if (items && items.length > 0) {
            $.each(items, function(_, item) {
                if (item.product_id) { hasProducts = true; return false; }
            });
        }
        if (hasProducts) { $addAllBtn.show(); } else { $addAllBtn.hide(); }

        if (!items || !items.length) {
            if (isNewDesign) {
                if (!$emptyAlert.length) {
                    $emptyAlert = $('<div class="alert alert-warning rec-no-results-alert"></div>');
                    $tableWrapper.append($emptyAlert);
                }
                $emptyAlert.text(labels.noRecommendations).show();
                $table.hide();
            } else {
                $emptyAlert.hide();
                $table.show();
                $tbody.append('<tr><td colspan="6">' + labels.noRecommendations + '</td></tr>');
            }
            return;
        }

        if (isNewDesign) {
            $emptyAlert.hide();
            $table.show();
        }

        $.each(items, function(_, it) {
            var supplierId = it.supplier_id ? it.supplier_id : '';
            var img = self._buildImageHtml(it.image, supplierId, 48);
            var supplierSku = it.supplier_sku ? it.supplier_sku : (it.sku ? it.sku : '');
            var name = it.name ? it.name : '';
            var price = it.price ? it.price : '';
            var nameCell = it.url ? '<a href="' + it.url + '">' + name + '</a>' : name;
            var productId = it.product_id || '';
            var recommendationSource = it.recommendation_source || (it.source === 'system' ? 'SYS' : 'ORG');
            var rowId = 'rec-row-' + containerId + '-' + (it.index || it.pk || Math.random().toString(36).substr(2, 9));
            var qtyInputId = 'qty-' + rowId;

            var confidenceLevel = '';
            var confidenceClass = '';
            if (recommendationSource === 'SYS' && it.confidence_level) {
                confidenceLevel = it.confidence_level;
                if (confidenceLevel === 'HIGH')   { confidenceClass = 'confidence-high';   }
                else if (confidenceLevel === 'MEDIUM') { confidenceClass = 'confidence-medium'; }
                else if (confidenceLevel === 'LOW')    { confidenceClass = 'confidence-low';    }
            }

            var maxSaleQty    = it.max_sale_qty   && parseFloat(it.max_sale_qty)   > 0 ? parseFloat(it.max_sale_qty)   : 9999;
            var qtyIncrements = it.qty_increments && parseFloat(it.qty_increments) > 0 ? parseFloat(it.qty_increments) : 1;
            var minSaleQty    = it.min_sale_qty   && parseFloat(it.min_sale_qty)   > 0 ? parseFloat(it.min_sale_qty)   : 1;
            var initialQty = it.quantity && it.quantity > 0 ? parseInt(it.quantity) : 1;
            if (initialQty < minSaleQty)  { initialQty = minSaleQty;  }
            if (initialQty > maxSaleQty)  { initialQty = maxSaleQty;  }

            var qtyCell    = '';
            var actionsHtml = '';

            if (productId) {
                var cartParams = JSON.stringify({ id: productId, qty: initialQty });
                qtyCell =
                    '<div class="qty-pill">' +
                        '<button type="button" class="qty-btn qty-decrement" data-qty-input="#' + qtyInputId + '" aria-label="' + labels.decreaseQty + '" title="' + labels.decreaseQty + '"><span class="fa fa-minus"></span></button>' +
                        '<input type="text" name="qty" id="' + qtyInputId + '" class="form-control product-qty" value="' + initialQty + '" min="' + minSaleQty + '" max="' + maxSaleQty + '" />' +
                        '<button type="button" class="qty-btn qty-increment" data-qty-input="#' + qtyInputId + '" aria-label="' + labels.increaseQty + '" title="' + labels.increaseQty + '"><span class="fa fa-plus"></span></button>' +
                    '</div>';

                var isConfigurable = it.is_configurable === true || it.is_configurable === 1 || it.is_configurable === '1';
                var ignoreButtonHtml = isNewDesign
                    ? '<span class="btn-ignore-rec action-icon-circle delete" data-row-id="' + rowId + '" aria-label="' + labels.ignore + '" title="' + labels.ignore + '"><span class="fa fa-trash-o"></span></span>'
                    : '<button type="button" class="close btn-ignore-rec rec-btn-mr-lg" data-row-id="' + rowId + '" aria-label="' + labels.ignore + '" title="' + labels.ignore + '">x</button>';
                if (isConfigurable) {
                    actionsHtml =
                        '<a href="' + it.url + '" class="btn btn-primary btn-sm rec-btn-mr-lg rec-btn--min-md" aria-label="' + labels.configure + '" title="' + labels.configure + '">' + labels.configure + '</a>' +
                        ignoreButtonHtml;
                } else {
                    actionsHtml =
                        '<button type="button" class="btn btn-primary btn-sm rec-btn-mr-lg rec-btn--min-md" data-bq="add-cart" data-params=\'' + cartParams + '\' data-qty-input="#' + qtyInputId + '" aria-label="' + labels.addToCart + '" title="' + labels.addToCart + '"><span class="fa fa-shopping-cart"></span></button>' +
                        ignoreButtonHtml;
                }
            } else {
                actionsHtml = '<span class="text-muted">' + labels.productNotFound + '</span>';
            }

            $tbody.append(
                '<tr class="bq-suggested-row ' + confidenceClass + '" id="' + rowId + '"' +
                    ' data-sku="' + $('<div/>').text(supplierSku).html() + '"' +
                    ' data-supplier="' + $('<div/>').text(supplierId).html() + '"' +
                    ' data-product-id="' + productId + '"' +
                    ' data-recommendation-source="' + recommendationSource + '"' +
                    ' data-confidence-level="' + confidenceLevel + '"' +
                    ' data-is-configurable="' + (it.is_configurable ? '1' : '0') + '"' +
                    ' data-qty-increments="' + qtyIncrements + '"' +
                    ' data-min-sale-qty="' + minSaleQty + '"' +
                    ' data-max-sale-qty="' + maxSaleQty + '">' +
                    '<td class="product-image">' + img + '</td>' +
                    '<td class="product-name">' + nameCell + '</td>' +
                    '<td class="product-sku">' + supplierSku + '</td>' +
                    '<td class="product-price">' + price + '</td>' +
                    '<td class="product-qty">' + qtyCell + '</td>' +
                    '<td class="text-right product-actions">' + actionsHtml + '</td>' +
                '</tr>'
            );
        });

        self._$('-suggested [data-bq="add-cart"]').each(function() {
            var $button = $(this);
            var $qtyInput = $($button.data('qty-input'));

            $qtyInput.on('change blur', function() {
                var rowMaxQty = parseFloat($qtyInput.closest('tr.bq-suggested-row').attr('data-max-sale-qty')) || 9999;
                var qty = parseInt($(this).val()) || 1;
                if (qty < 1)          { qty = 1;          }
                if (qty > rowMaxQty)  { qty = rowMaxQty;  }
                $(this).val(qty);
                var params = JSON.parse($button.attr('data-params') || '{}');
                params.qty = qty;
                $button.attr('data-params', JSON.stringify(params));
                $button.data('params', params);
            });

            $button.on('click.rec-qty-update', function() {
                var rowMaxQty = parseFloat($qtyInput.closest('tr.bq-suggested-row').attr('data-max-sale-qty')) || 9999;
                var qty = parseInt($qtyInput.val()) || 1;
                if (qty < 1)          { qty = 1;          }
                if (qty > rowMaxQty)  { qty = rowMaxQty;  }
                $qtyInput.val(qty);
                var params = JSON.parse($button.attr('data-params') || '{}');
                params.qty = qty;
                $button.attr('data-params', JSON.stringify(params));
                $button.data('params', params);
            });

            $button.on('bq.ajaxAction.processStart', function() {
                var rowMaxQty = parseFloat($qtyInput.closest('tr.bq-suggested-row').attr('data-max-sale-qty')) || 9999;
                var qty = parseInt($qtyInput.val()) || 1;
                if (qty < 1)          { qty = 1;          }
                if (qty > rowMaxQty)  { qty = rowMaxQty;  }
                var params = JSON.parse($button.attr('data-params') || '{}');
                params.qty = qty;
                $button.attr('data-params', JSON.stringify(params));
                $button.data('params', params);
                var ajaxAction = $button.data('bq.ajaxAction');
                if (ajaxAction && ajaxAction.options) {
                    ajaxAction.options.params = params;
                }
            });
        });

        self._$('-suggested .product-qty').each(function() {
            var $input  = $(this);
            var qty     = parseInt($input.val()) || 1;
            var $pill   = $input.closest('.qty-pill');
            var $row    = $input.closest('tr.bq-suggested-row');
            var minQty  = parseFloat($row.attr('data-min-sale-qty')) || 1;
            var maxQty  = parseFloat($row.attr('data-max-sale-qty')) || 9999;
            $pill.find('.qty-decrement').prop('disabled', qty <= minQty);
            $pill.find('.qty-increment').prop('disabled', qty >= maxQty);
        });

        if (typeof bq !== 'undefined' && typeof bq.global !== 'undefined' && typeof bq.global.registerAjaxActions === 'function') {
            bq.global.registerAjaxActions();
        }
    },

    _load: function() {
        var self = this;
        this._$('-error').hide().text('');
        this._$('-list').hide();
        this._$('-loading').show();

        $.ajax({
            url: this.options.combinedUrl,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({})
        }).done(function(resp) {
            self._$('-loading').hide();
            var hasData   = resp && (resp.forecasts || resp.system_recommendations || resp.org_recommendations);
            var isSuccess = resp && (resp.success === true || (resp.success === undefined && hasData));

            if (isSuccess || hasData) {
                if (resp.forecasts) {
                    var split = self._splitForecastsBySource(resp.forecasts);
                    self._allSystemItems = split.system;
                    self._allOrgItems    = split.org;
                } else {
                    self._allSystemItems = resp.system_recommendations || [];
                    self._allOrgItems    = resp.org_recommendations    || [];
                }
                self._modelStartDate = resp.model_start_date || '';
                self._modelEndDate   = resp.model_end_date   || '';
                var filterToApply = self.options.disableWidgetClassification ? 'all' : self._currentFilter;
                self._sortAndFilterItems(filterToApply);
                self._$('-list').show();
            } else {
                var errorMsg = resp && resp.message ? resp.message : bq.messages.recommendations.loadFailed;
                self._$('-error').text(errorMsg).show();
            }
        }).fail(function(xhr) {
            self._$('-loading').hide();
            var errorMsg = bq.messages.recommendations.loadFailed;
            if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
                errorMsg = xhr.responseJSON.message;
            }
            self._$('-error').text(errorMsg).show();
        });
    },

    _updateQtyButtonStates: function($qtyInput) {
        var qty    = parseInt($qtyInput.val()) || 1;
        var $pill  = $qtyInput.closest('.qty-pill');
        var $row   = $qtyInput.closest('tr.bq-suggested-row');
        var minQty = parseFloat($row.attr('data-min-sale-qty')) || 1;
        var maxQty = parseFloat($row.attr('data-max-sale-qty')) || 9999;
        $pill.find('.qty-decrement').prop('disabled', qty <= minQty);
        $pill.find('.qty-increment').prop('disabled', qty >= maxQty);
    },

    _addAllToCart: function($button) {
        var self = this;
        var $allButtons = this._$addAllCart();
        var $rows = this._$('-suggested tbody tr.bq-suggested-row:visible');
        var itemsToAdd = [];

        $rows.each(function() {
            var $row = $(this);
            var productId = $row.data('product-id');
            var confidenceLevel = $row.data('confidence-level') || '';
            var recommendationSource = $row.data('recommendation-source') || '';
            var isConfigurable = $row.data('is-configurable') === 1 || $row.data('is-configurable') === '1' || $row.data('is-configurable') === true;
            if (isConfigurable || !productId) { return; }

            var shouldInclude = (recommendationSource === 'ORG' || !confidenceLevel) ||
                                self._selectedConfidenceLevels.indexOf(confidenceLevel) !== -1;
            if (!shouldInclude) { return; }

            var $qtyInput = $row.find('.product-qty');
            var rowMaxQty = parseFloat($row.attr('data-max-sale-qty')) || 9999;
            var minQty    = parseFloat($row.attr('data-min-sale-qty')) || 1;
            var qty = parseInt($qtyInput.val()) || minQty;
            if (qty < minQty)    { qty = minQty;    }
            if (qty > rowMaxQty) { qty = rowMaxQty; }
            itemsToAdd.push({ productId: productId, qty: qty, $row: $row, sku: $row.data('sku'), supplier: $row.data('supplier'), recommendationSource: recommendationSource });
        });

        if (!itemsToAdd.length) { return; }

        var originalText = $allButtons.first().text();
        $allButtons.prop('disabled', true);

        if (!this._isNewDesign()) {
            $allButtons.text(bq.messages.recommendations.adding);
        }

        var finishAddAll = function() {
            $allButtons.prop('disabled', false);
            if (!self._isNewDesign()) {
                $allButtons.text(originalText);
            }
        };

        var addNextItem = function(index) {
            if (index >= itemsToAdd.length) {
                finishAddAll();
                return;
            }

            var item = itemsToAdd[index];
            var $addCartBtn = item.$row.find('[data-bq="add-cart"]');

            if (!$addCartBtn.length || !item.$row.is(':visible')) {
                addNextItem(index + 1);
                return;
            }

            var params = { id: item.productId, qty: item.qty };
            $addCartBtn.attr('data-params', JSON.stringify(params));
            $addCartBtn.data('params', params);

            var completed = false;
            var timeoutId = setTimeout(function() {
                if (completed) { return; }
                completed = true;
                $addCartBtn.off('.addAllCart');
                addNextItem(index + 1);
            }, 30000);

            $addCartBtn.one('bq.ajaxAction.processDone.addAllCart bq.ajaxAction.error.addAllCart', function() {
                if (completed) { return; }
                completed = true;
                clearTimeout(timeoutId);
                setTimeout(function() { addNextItem(index + 1); }, 100);
            });

            $addCartBtn.trigger('click');
        };

        addNextItem(0);
    },

    _bindEvents: function() {
        var self = this;
        var containerId = this._id();

        this._$('-confidence-filter-toggle').on('click', function(e) {
            e.preventDefault();
            self._$('-confidence-filter-dropdown').toggle();
        });

        $(document).on('click.forecastsWidget.' + containerId, function(e) {
            var $target = $(e.target);
            if (!$target.closest('#' + containerId + '-confidence-filter-toggle').length &&
                !$target.closest('#' + containerId + '-confidence-filter-dropdown').length) {
                self._$('-confidence-filter-dropdown').hide();
            }
        });

        this._$('-confidence-filter-dropdown').on('change', '.confidence-checkbox', function() {
            self._selectedConfidenceLevels = [];
            self._$('-confidence-filter-dropdown .confidence-checkbox:checked').each(function() {
                self._selectedConfidenceLevels.push($(this).val());
            });
            self._sortAndFilterItems(self._currentFilter);
        });

        this.$el.find('.filter-toggles').on('click', '.filter-toggle', function() {
            if (self.options.disableWidgetClassification) { return; }
            var $button = $(this);
            var filter = $button.data('filter');
            self.$el.find('.filter-toggle').each(function() {
                var $btn = $(this);
                if (self._isNewDesign()) {
                    $btn.toggleClass('active', $btn.is($button));
                } else if ($btn.is($button)) {
                    $btn.removeClass('btn-default').addClass('btn-primary active');
                } else {
                    $btn.removeClass('btn-primary active').addClass('btn-default');
                }
            });
            self._currentFilter = filter;
            self._sortAndFilterItems(self._currentFilter);
        });

        this._$addAllCart().on('click', function() {
            self._addAllToCart($(this));
        });

        this._$('-suggested').on('click', '.qty-increment, .qty-decrement', function(e) {
            e.preventDefault();
            var $button = $(this);
            if ($button.prop('disabled')) { return; }
            var $qtyInput = $($button.data('qty-input'));
            if (!$qtyInput.length) { return; }
            var $row   = $qtyInput.closest('tr.bq-suggested-row');
            var step   = parseFloat($row.attr('data-qty-increments')) || 1;
            var minQty = parseFloat($row.attr('data-min-sale-qty'))   || 1;
            var maxQty = parseFloat($row.attr('data-max-sale-qty'))   || 9999;
            var currentQty = parseInt($qtyInput.val()) || minQty;
            var newQty = $button.hasClass('qty-increment') ? currentQty + step : currentQty - step;
            if (newQty < minQty) { newQty = minQty; }
            if (newQty > maxQty) { newQty = maxQty; }
            $qtyInput.val(newQty).trigger('change');
            self._updateQtyButtonStates($qtyInput);
            var $addCartBtn = $qtyInput.closest('tr').find('[data-bq="add-cart"]');
            if ($addCartBtn.length) {
                var params = JSON.parse($addCartBtn.attr('data-params') || '{}');
                params.qty = newQty;
                $addCartBtn.attr('data-params', JSON.stringify(params));
                $addCartBtn.data('params', params);
            }
        });

        this._$('-suggested').on('change blur', '.product-qty', function() {
            var $qtyInput = $(this);
            var $row   = $qtyInput.closest('tr.bq-suggested-row');
            var minQty = parseFloat($row.attr('data-min-sale-qty')) || 1;
            var maxQty = parseFloat($row.attr('data-max-sale-qty')) || 9999;
            var qty    = parseInt($qtyInput.val()) || minQty;
            if (qty < minQty) { qty = minQty; }
            if (qty > maxQty) { qty = maxQty; }
            $qtyInput.val(qty);
            self._updateQtyButtonStates($qtyInput);
        });

        this._$('-suggested').on('click', '.btn-ignore-rec', function() {
            var $button = $(this);
            var $tr     = $('#' + $button.data('row-id'));
            var productId = $tr.data('product-id');
            var sku       = $tr.data('sku');
            var supplier  = $tr.data('supplier');
            var recommendationSource = $tr.data('recommendation-source');
            if (recommendationSource) {
                self._logRecommendationAction(
                    productId ? String(productId) : '',
                    String(supplier || ''),
                    String(sku || ''),
                    recommendationSource, 'IGNORE', self._getContentGroupId()
                );
            }
            self._removeItemFromMemory(productId, supplier, sku, recommendationSource);
            $tr.fadeOut(300, function() {
                $(this).remove();
                self._refreshIfEmpty();
            });
        });

        $(document).on('bq.ajaxAction.processDone.forecastsWidget.' + containerId, function(e) {
            var $button = $(e.target);
            if (!$button.closest('#' + containerId).length) { return; }
            if (!$button.is('[data-bq="add-cart"]') && !$button.closest('[data-bq="add-cart"]').length) { return; }
            if (!$button.is('[data-bq="add-cart"]')) { $button = $button.closest('[data-bq="add-cart"]'); }
            var $tr = $button.closest('tr.bq-suggested-row');
            if (!$tr.length) { return; }
            var productId = $tr.data('product-id');
            var sku       = $tr.data('sku');
            var supplier  = $tr.data('supplier');
            var recommendationSource = $tr.data('recommendation-source');
            if (recommendationSource) {
                self._logRecommendationAction(
                    productId ? String(productId) : '',
                    String(supplier || ''),
                    String(sku || ''),
                    recommendationSource, 'ADD', self._getContentGroupId()
                );
            }
            self._removeItemFromMemory(productId, supplier, sku, recommendationSource);
            $tr.fadeOut(300, function() {
                $(this).remove();
                self._refreshIfEmpty();
            });
        });
    }

};

// Plugin definition
// =================

var oldForecastsWidget = $.fn.forecastsWidget;

$.fn.forecastsWidget = function(option) {
    return this.each(function() {
        var $this   = $(this);
        var data    = $this.data('bq.forecastsWidget');
        var options = $.extend(true, {}, bq.forecastsWidget.DEFAULTS, $this.data(), typeof option === 'object' && option);
        if (!data) { $this.data('bq.forecastsWidget', (data = new bq.forecastsWidget(this, options))); }
        data.init();
    });
};

$.fn.forecastsWidget.Constructor = bq.forecastsWidget;

$.fn.forecastsWidget.noConflict = function() {
    $.fn.forecastsWidget = oldForecastsWidget;
    return this;
};

bq.forecastsWidgetInit = function() {
    $('[data-bq="forecasts-widget"]').each(function() {
        var $el = $(this);
        if ($el.data('bq.forecastsWidget')) { return; }
        $el.forecastsWidget($el.data());
    });
};

bq.init.push(bq.forecastsWidgetInit);
bq.forecastsWidgetInit();
